// extracted by mini-css-extract-plugin
module.exports = {"Arielle":"TextGroupSectionG_Arielle__14e0Y","TextContainer":"TextGroupSectionG_TextContainer__2bEXd"};